import {
  Database,
  Table2,
  Activity,
  BookOpen,
  MessageSquare,
  FileText,
  BellRing,
  Radio,
  Network,
  ShieldCheck,
  ScrollText,
  Sparkles,
  Check,
} from "lucide-react";
import { Section } from "./Section";
import { FEATURES } from "@/content/landing";

const ICONS = {
  Database,
  Table2,
  Activity,
  BookOpen,
  MessageSquare,
  FileText,
  BellRing,
  Radio,
  Network,
  ShieldCheck,
  ScrollText,
};

export function Features() {
  return (
    <Section
      id="product"
      testId="landing-features"
      eyebrow={FEATURES.eyebrow}
      title={FEATURES.title}
      subtitle={FEATURES.subtitle}
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
        {FEATURES.cards.map((c, i) => {
          const Icon = ICONS[c.icon] ?? Sparkles;
          return (
            <article
              key={c.title}
              data-testid={`landing-feature-card-${i}`}
              className="group relative flex flex-col rounded-2xl border border-border/60 bg-card/60 p-7 transition-colors hover:border-accent/50"
            >
              <div className="mb-5 inline-flex h-10 w-10 items-center justify-center rounded-xl border border-border/60 bg-background text-accent transition-colors group-hover:border-accent/60">
                <Icon className="h-5 w-5" strokeWidth={1.6} />
              </div>
              <h3 className="text-lg font-semibold text-foreground">
                {c.title}
              </h3>
              <p className="mt-2 text-sm text-muted-foreground">{c.claim}</p>
              <ul className="mt-5 space-y-2.5">
                {c.bullets.map((b, j) => (
                  <li
                    key={j}
                    className="flex items-start gap-2 text-[13px] leading-relaxed text-muted-foreground"
                  >
                    <Check
                      className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-accent"
                      strokeWidth={2.2}
                    />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </article>
          );
        })}
      </div>
    </Section>
  );
}
